<style src="./AnalyticMonthlyPdv.scss" lang="scss"></style>
<template>
  <section
    class="
      employee-monthly-resume-credit
      wrapper wrapper-content
      animated
      fadeInRight
    "
  >
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="generateReport">
        <div class="formContainer">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="col-sm-12">Colaborador</label>
              <select class="form-control m-b" v-model="form.employeeId">
                <option value>Todos</option>
                <option
                  v-for="(item, idx) in employeeList"
                  :key="idx"
                  :value="item.id"
                >
                  {{ item.fullName }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Mês</label>
              <div class="col-sm-12">
                <select class="form-control" v-model="form.reportMonth">
                  <option
                    v-for="(thisMonth, monthIdx) in monthList"
                    :key="monthIdx"
                    :value="monthIdx"
                  >
                    {{ thisMonth }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Ano</label>
              <div class="col-sm-12">
                <select class="form-control" v-model="form.reportYear">
                  <option
                    v-for="(thisYear, yearIdx) in yearList"
                    :key="yearIdx"
                    :value="thisYear"
                  >
                    {{ thisYear }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="submit"
              :disabled="isLoading"
            >
              <i v-show="!isLoading" class="fa fa-search"></i>
              <i v-show="isLoading" class="fa-spin fa fa-spinner"></i>
              Gerar Relatório
            </button>
          </div>
        </div>
      </form>
    </div>

    <template v-if="reportDetails">
      <section class="row result animated fadeInRight">
        <div class="col-lg-3">
          <div class="widget navy-bg">
            <h3 class="no-margin">Vendas</h3>
            <div class="row">
              <div class="col-md-8">
                <small class="font-bold">Saldo R$</small>
                <h1>
                  {{ totalToCurrencyBR(reportDetails.totalSettledGlobal) }}
                </h1>
              </div>
              <div class="col-md-4">
                <small class="font-bold">Tickets</small>
                <h1 class="text-primary">
                  {{ reportDetails.countRegularGlobal }}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget yellow-bg">
            <h3 class="no-margin">Regularização</h3>
            <div class="row">
              <div class="col-md-8">
                <small class="font-bold">Vendas R$</small>
                <h1>
                  {{ totalToCurrencyBR(Math.abs(reportDetails.totalRegularizedGlobal)) }}
                </h1>
              </div>
              <div class="col-md-4">
                <small class="font-bold">Tickets</small>
                <h1 class="text-primary">
                  {{ reportDetails.countRegularizedGlobal }}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget red-bg">
            <h3 class="no-margin">Irregularidades</h3>
            <div class="row">
              <div class="col-md-8">
                <small class="font-bold">Saldo R$</small>
                <h1>
                  {{ totalToCurrencyBR(Math.abs(reportDetails.totalAmountIrregularGlobal)) }}
                </h1>
              </div>
              <div class="col-md-4">
                <small class="font-bold">Tickets</small>
                <h1 class="text-primary">
                  {{ reportDetails.countIrregularGlobal }}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget blue-bg">
            <h3 class="no-margin">Especiais</h3>
            <div class="row">
              <div class="col-md-8">
                <small class="font-bold">Estimativa R$</small>
                <h1>
                  {{ totalToCurrencyBR(Math.abs(reportDetails.totalSpecialEstimateGlobal)) }}
                </h1>
              </div>
              <div class="col-md-4">
                <small class="font-bold">Tickets</small>
                <h1 class="text-primary">
                  {{ reportDetails.countSpecialGlobal }}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="row result animated fadeInRight">
        <div class="col-lg-3">
          <div class="panel panel-default">
            <div class="panel-heading">Tempo Negociado</div>
            <div class="panel-body">
              <div class="no-margins">
                <div class="row">
                  <div class="col-md-4">
                    <small class="stats-label">Regular</small>
                    <h1 class="text-info">
                      {{ timeConvert(reportDetails.totalRegularMinutesGlobal) }}
                    </h1>
                  </div>
                  <div class="col-md-4">
                    <small class="stats-label">Irregular</small>
                    <h1 class="text-danger">
                      {{ timeConvert(reportDetails.totalIrregularMinutesGlobal) }}
                    </h1>
                  </div>
                  <div class="col-md-4">
                    <small class="stats-label">Especial</small>
                    <h1 class="text-success">
                      {{ timeConvert(reportDetails.totalSpecialMinutesGlobal) }}
                    </h1>
                  </div>
                </div>
                <div class="stat-percent">
                  <small>Total</small>
                  <span class="font-bold text-navy:">
                    {{ timeConvert((reportDetails.totalRegularMinutesGlobal +
                        reportDetails.totalIrregularMinutesGlobal +
                        reportDetails.totalSpecialMinutesGlobal)) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h3>Entrada</h3>
            </div>
            <div class="panel-body">
              <div class="no-margins">
                <div class="row">
                  <div class="col-md-6">
                    <small>Saldo R$</small>
                    <h1 class="text-primary">
                      {{ totalToCurrencyBR(reportDetails.cash.settledPaid) }}
                    </h1>
                  </div>
                  <div class="col-md-6">
                    <small>Ticket</small>
                    <h1 class="text-primary">{{ reportDetails.cash.count }}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3" v-if="hasWalletUsagePermission">
          <div class="panel panel-warning">
            <div class="panel-heading">
              <h5>Créditos do Usuário</h5>
            </div>
            <div class="panel-body">
              <div class="no-margins">
                <div class="row">
                  <div class="col-md-6">
                    <small>Saldo R$</small>
                    <h1 class="text-primary">
                      {{ totalToCurrencyBR(reportDetails.wallet.settledPaid) }}
                    </h1>
                  </div>
                  <div class="col-md-6">
                    <small>Tickets</small>
                    <h1 class="text-primary">
                      {{ reportDetails.wallet.count }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3" v-if="hasWalletPermission">
          <div class="panel panel-warning">
            <div class="panel-heading">
              <h5>App do Usuário</h5>
            </div>
            <div class="panel-body">
              <div class="no-margins">
                <div class="row">
                  <div class="col-md-6" v-if="hasCreditcardPermission">
                    <small>Cartões R$</small>
                    <h1 class="text-primary">
                      {{ totalToCurrencyBR(reportDetails.walletSold.totalCard) }}
                    </h1>
                  </div>
                  <div class="col-md-6" v-if="hasPixPermission">
                    <small>Entrada R$</small>
                    <h1 class="text-primary">
                      {{ totalToCurrencyBR(reportDetails.walletSold.totalPix) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="row result animated fadeInRight">
        <div class="col-lg-3" v-if="hasCreditPermission">
          <div class="panel panel-success">
            <div class="panel-heading">
              <h5>Crédito</h5>
            </div>
            <div class="panel-body">
              <div class="no-margins">
                <div class="row">
                  <div class="col-md-6">
                    <small>Saldo R$</small>
                    <h1 class="text-primary">
                      {{ totalToCurrencyBR(reportDetails.credit.settledPaid) }}
                    </h1>
                  </div>
                  <div class="col-md-6">
                    <small>Ticket</small>
                    <h1 class="text-primary">
                      {{ reportDetails.credit.count }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3" v-if="hasDebitPermission">
          <div class="panel panel-success">
            <div class="panel-heading">
              <h5>Débito</h5>
            </div>
            <div class="panel-body">
              <div class="no-margins">
                <div class="row">
                  <div class="col-md-6">
                    <small>Saldo R$</small>
                    <h1 class="text-primary">
                      {{ totalToCurrencyBR(reportDetails.debit.settledPaid) }}
                    </h1>
                  </div>
                  <div class="col-md-6">
                    <small>Ticket</small>
                    <h1 class="text-primary">
                      {{ reportDetails.debit.count }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section clas="row result" v-if="reportDetails">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Planos Regulares</h5>
            </div>
            <div class="ibox-content table-responsive">
              <table class="table table-hover no-margins">
                <thead>
                  <tr>
                    <th>Plano</th>
                    <th>Tickets</th>
                    <th>Minutos</th>
                    <th>Venda</th>
                    <th>Desconto</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(regularSale,
                    regularSaleIdx) in reportDetails.regularSale"
                    :key="regularSaleIdx"
                  >
                    <td>{{ regularSaleIdx }}</td>
                    <td>{{ regularSale.count }}</td>
                    <td>{{ timeConvert(regularSale.totalMinutes) }}</td>
                    <td>
                      {{ totalToCurrencyBR(regularSale.totalAmountPaid) }}
                    </td>
                    <td>
                      {{ totalToCurrencyBR((Math.abs(regularSale.totalAmountPaid) -
                          regularSale.totalSettledPaid)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Planos Irregulares</h5>
            </div>
            <div class="ibox-content table-responsive">
              <table class="table table-hover no-margins">
                <thead>
                  <tr>
                    <th>Plano</th>
                    <th>Tickets</th>
                    <th>Minutos</th>
                    <th>Venda</th>
                    <th>Desconto</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(irregularSale,
                    irregularSaleIdx) in reportDetails.irregularSale"
                    :key="irregularSaleIdx"
                  >
                    <td>{{ irregularSaleIdx }}</td>
                    <td>{{ irregularSale.count }}</td>
                    <td>{{ timeConvert(irregularSale.totalMinutes) }}</td>
                    <td>
                      {{ totalToCurrencyBR(irregularSale.totalAmountPaid) }}
                    </td>
                    <td>
                      0,00
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Planos Especiais</h5>
            </div>
            <div class="ibox-content table-responsive">
              <table class="table table-hover no-margins">
                <thead>
                  <tr>
                    <th>Plano</th>
                    <th>Tickets</th>
                    <th>Minutos</th>
                    <th>Venda</th>
                    <th>Desconto</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(specialSale,
                    specialSaleIdx) in reportDetails.specialSale"
                    :key="specialSaleIdx"
                  >
                    <td>{{ specialSaleIdx }}</td>
                    <td>{{ specialSale.count }}</td>
                    <td>{{ timeConvert(specialSale.totalMinutes) }}</td>
                    <td>
                      {{ totalToCurrencyBR(specialSale.totalAmountPaid) }}
                    </td>
                    <td>
                      {{ totalToCurrencyBR((specialSale.totalAmountPaid -
                          specialSale.totalSettledPaid)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </template>
  </section>
</template>

<script>
import moment from 'moment';
import { toast } from '@/plugins/toast';

export default {
  name: 'AnalyticMonthlyPdv',
  data: () => ({
    isLoading: false,
    form: {
      employeeId: '',
      reportMonth: new Date().getMonth(),
      reportYear: new Date().getFullYear().toString(),
    },
    monthList: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    yearList: [
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
      '2026',
      '2027',
      '2028',
      '2029',
      '2030',
    ],
    employeeList: [],
    reportDetails: null,
  }),
  computed: {
    hasWalletUsagePermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-monthly-sales-pdv-displays-wallet-usage',
        'SHOW',
      );
    },
    hasWalletPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-monthly-sales-pdv-displays-wallet',
        'SHOW',
      );
    },
    hasPixPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-monthly-sales-pdv-displays-wallet-pix',
        'SHOW',
      );
    },
    hasCreditcardPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-monthly-sales-pdv-displays-wallet-creditcard',
        'SHOW',
      );
    },

    hasDebitPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-monthly-sales-pdv-displays-debit',
        'SHOW',
      );
    },
    hasCreditPermission() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'report-monthly-sales-pdv-displays-credit',
        'SHOW',
      );
    },
  },
  mounted() {
    this.listEmployee();
    this.form.reportDate = moment(new Date()).format('YYYY-MM-DD');
  },
  methods: {
    totalToCurrencyBR(value) {
      if (!value) {
        return '0,00';
      }
      return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    timeConvert(n) {
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours)
        .toString()
        .padStart(2, '0');
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes)
        .toString()
        .padStart(2, '0');
      return `${rhours}:${rminutes}`;
    },
    async listEmployee() {
      const employeeListFull = await this.$store.dispatch(
        'REPORTS/AnalyticsPdvUsers',
      );
      const employeeList = employeeListFull.map(item => ({
        id: item._id,
        fullName: item.fullName,
      }));
      this.employeeList = employeeList;
    },
    async generateReport() {
      const startDate = new Date(
        this.form.reportYear,
        this.form.reportMonth,
        1,
        0,
        0,
        0,
      );
      const isSameMonth =
        this.form.reportMonth === new Date().getMonth();
      const lastDayOfMonth = new Date(this.form.reportYear, this.form.reportMonth + 1, 0).getDate();
      const currentDay = isSameMonth ? new Date().getDate() : lastDayOfMonth;

      const endDate = new Date(
        this.form.reportYear,
        this.form.reportMonth,
        currentDay,
        20,
        59,
        59,
      );

      const query = {
        employeeId: this.form.employeeId,
        startDate,
        endDate,
      };
      try {
        this.isLoading = true;
        const reportResult = await this.$store.dispatch(
          'REPORTS/AnalyticsPdvMonthly',
          { query },
        );
        this.reportDetails = reportResult && reportResult.creditList;
      } catch (error) {
        toast.error('Não foi possível gerar o relatório');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
